// UpdateResponsablePage.tsx
import { useParams } from "react-router-dom";
import { LoaderComponent } from "@/shared/components/ui";
import { useFetchGetByIdResponsable } from "@/shared/actions";
import SaveResponsable from "../../components/save-responsable/SaveResponsable";

export default function UpdateResponsablePage() {
  const { id } = useParams();

  const { data, isLoading, isRefetching } = useFetchGetByIdResponsable(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;

  return (
    <SaveResponsable
      titulo="Actualizar Responsable"
      data={data?.data}
    />
  );
}
